export default function imagesPairs(data) {
  const result = []

  const dataCopy = [...data]

  while (dataCopy.length > 1) {
    const img1 = dataCopy.splice(0, 1)
    const img2 = dataCopy.splice(0, 1)

    result.push([...img1, ...img2])
  }

  return result
}
